<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <img :src="require('@/assets/images/banner.png')" alt="" style="width: 80%">
        </b-link>

        <b-card-title class="mb-1">
          إنشاء حساب جديد
        </b-card-title>

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="dox()"
          >

            <template v-if="requireOTP">
              <!-- OTP -->
              <b-form-group
                label-for="OTP"
                label="OTP"
              >
                <validation-provider
                  #default="{ errors }"
                  name="OTP"
                  rules="required"
                >
                  <b-form-input
                    id="email" class="form-control-lg"
                    v-model="otp"
                    name="login-email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="OTP here..."
                    autofocus
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>
            <template v-if="!requireOTP">
              <!-- email -->
              <b-form-group
                label-for="emailx"
                label="الاسم"
              >
                <validation-provider
                  #default="{ errors }"
                  name="الاسم"
                  rules="required"
                >
                  <b-form-input
                    id="emailx" class="form-control-lg"
                    v-model="name"
                    name="login-emailx"
                    :state="errors.length > 0 ? false:null"
                    placeholder="الاسم هنا..."
                    autofocus
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- email -->
              <b-form-group
                label-for="email"
                label="رقم الجوال"
              >
                <validation-provider
                  #default="{ errors }"
                  name="رقم الجوال"
                  rules="required"
                >
                  <b-form-input
                    id="email" class="form-control-lg"
                    v-model="userEmail"
                    name="login-email"
                    :state="errors.length > 0 ? false:null"
                    placeholder="رقم الجوال هنا..."
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="password">كلمة المرور</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="كلمة المرور"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="password" 
                      v-model="password"
                      :type="passwordFieldType"
                      class="form-control-merge form-control-lg"
                      :state="errors.length > 0 ? false:null"
                      name="login-password"
                      placeholder="كلمة المرور هنا..."
                    />

                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </template>

            <div class="alert alert-danger text-center g" id="error" v-if="error">
              {{ error }}
            </div>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
            >
              إنشاء الحساب
            </b-button>
          </b-form>
          <div class="col-12 text-center g"><br>
            <a href="/login" class="text-info">
              <i class="fa fa-user-plus"></i>
              تسجيل الدخول
            </a>
          </div>
        </validation-observer>

      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  created(){
    var g = this;
    if(window.location.href.includes("username=")){
      g.dox()
    }
  },
  methods: {
    dox(){
      var g = this;
      g.error = null;
        $.post(api + '/user/auth/register', {
          phone: g.userEmail,
          name: g.name,
          password: g.password
        })
        .then(function(r){
          if(r.status != 100){
            g.error = r.response
          }else{
            g.$router.push('/login#ss')
          }
        })
        .fail(function(){
          g.error = "حدث خطأ عند الاتصال بالخادم"
        })
    }
  },
  data() {
    return {
      userEmail: window.location.href.includes("username=") ? window.location.href.split("username=")[1].split("&")[0] : "",
      password: window.location.href.includes("password=") ? window.location.href.split("password=")[1].split("&")[0] : "",
      error: null,
      status: '',
      requireOTP: false,
      otp: "",
      otp_id: "",
      name: "",
      pass: window.location.href.includes("?pass"),
      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
